import styled from 'styled-components';
import { boxShadow1 } from '../../../../utils/style/colors';

export const SurveyContainer = styled.div`
  width: calc(100% - 2rem);
  border-radius: 1rem;
  height: calc(100% - 2rem);
  max-height: 100%;
  overflow: visible;
  z-index: 1323;
  display: block;
  top: 10%;
  margin: 1rem;
  box-shadow: ${boxShadow1};
  background-color: var(--exact-white) !important;
  transition: all 0.5s ease-in-out;

  ${({ showAnimation, isOpen }) =>
    showAnimation
      ? `
        transform: scale(${isOpen ? '1' : '0.7'});
        opacity: ${isOpen ? '1' : '0'};
      `
      : `
        opacity: 1;
        transform: scaleX(1);
      `}
`;
